import { createSelector } from 'reselect';
import { AppState } from '../../reducers/root.reducer';

const state = (state: AppState) => state.auth2;

const getAuth = createSelector(state, (state) => state);

const getPasswordState = createSelector(getAuth, (auth) => auth.password);
const getPasswordRequest = createSelector(
    getPasswordState,
    (password) => password.request,
);
const getPasswordReset = createSelector(
    getPasswordState,
    (password) => password.reset,
);

const AuthSelectors = {
    getAuth,
    getPasswordState,
    getPasswordRequest,
    getPasswordReset,
};

export default AuthSelectors;
